export default "__VITE_ASSET__DFR0KA3Q__"